import {
  Box,
  Flex,
  Link,
  Text,
  useMultiStyleConfig,
  VStack,
} from '@chakra-ui/react';
import { externalLinks } from 'app/api.config';

export const MobileSettingsInformation = () => {
  const styles = useMultiStyleConfig('SettingsPageList', {});
  return (
    <VStack align="flex-start" spacing={0} w="full" pb="58px">
      <Box sx={styles.container}>
        <Flex
          sx={{ ...styles.textWrapper, pr: 0 }}
          w="full"
          height="full"
          flexDirection="column"
          justifyContent="center"
          textDecoration="none"
          _hover={{ textDecoration: 'none' }}
          href={externalLinks.signUp.TERMS_AND_CONDITIONS}
          as={Link}
          target="_blank"
        >
          <Text sx={styles.primaryText}>Terms of Use</Text>
        </Flex>
      </Box>
      <Box sx={styles.container}>
        <Flex
          sx={{ ...styles.textWrapper, pr: 0 }}
          w="full"
          height="full"
          flexDirection="column"
          justifyContent="center"
          textDecoration="none"
          _hover={{ textDecoration: 'none' }}
          href={externalLinks.signUp.PRIVACY_POLICY}
          as={Link}
          target="_blank"
        >
          <Text sx={styles.primaryText}>Privacy Policy</Text>
        </Flex>
      </Box>
    </VStack>
  );
};
